export class statusModel {
  
    constructor(
      public mail: string,
      public passw: string,
      public orders: any 
    ) {  }
  
  }


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/statusModel.ts